import type { Ledger, StoryBible } from '../../types';

function stableStringify(value: unknown): string {
  return JSON.stringify(value, (_key, v) => {
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      return Object.keys(v)
        .sort()
        .reduce<Record<string, unknown>>((acc, k) => {
          acc[k] = (v as Record<string, unknown>)[k];
          return acc;
        }, {});
    }
    return v;
  });
}

async function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function computeRoadmapHash(storyBible: StoryBible): Promise<string> {
  const plans = (storyBible.chapterPlans || []).map((p) => ({
    chapterNumber: p.chapterNumber,
    title: p.title,
    summary: p.summary,
    requiredBeats: p.requiredBeats,
    status: p.status,
  }));
  return sha256Hex(stableStringify(plans));
}

export async function computeAuthoritativeInputHash(input: {
  storyBible: StoryBible;
  ledger: Ledger;
  chapterNumber: number;
}): Promise<string> {
  const payload = {
    chapterNumber: input.chapterNumber,
    premise: input.storyBible.premise,
    volume: input.storyBible.volume,
    ledgerCharacters: input.ledger.characters,
    ledgerLocations: input.ledger.locations,
    ledgerInventory: input.ledger.inventory,
    plotPoints: input.ledger.plot_points,
    resolvedPlotPoints: input.ledger.resolved_plot_points,
    roadmapHash: await computeRoadmapHash(input.storyBible),
  };
  return sha256Hex(stableStringify(payload));
}
